import { combineReducers } from '@reduxjs/toolkit'
import search from './slices/searchStateSlice'
import login from './slices/loginSlice'
import _fetch from '../components/Data/DataState'

export default combineReducers({ search, _fetch, login })
